import * as React from "react";
import { connect } from "react-redux";
import { actions as nameActions } from 'src/actions/name.actions';
import { actions } from 'src/actions/main.actions';
import { actions as homeActions } from 'src/actions/home.actions';
import Toasts from "./toast";
import { IApplicationState } from "../../typings";

interface IToastContainerProps{
    messages: any;
}

interface IToastContainerState{
}

class ToastContainer extends React.Component<IToastContainerProps & typeof actions & typeof homeActions, IToastContainerState>{

    constructor(props: any){
    super(props);
        this.state =  {
        }
    }

    onDelete = (id: string) => {
        (window as any).store.dispatch({type: "HIDE_TOAST_MESSAGE", v: id})
    }
    public render(){
        return (
            <Toasts onDelete={this.onDelete} {...this.props} />
        );
    }

}

function mapStateToProps(state: IApplicationState, ownProps: any): any {
    return {
        ...ownProps,
        messages: state.toasts.messages
        }
}
export default connect(mapStateToProps, {...actions, ...nameActions, ...homeActions})(ToastContainer);


// WEBPACK FOOTER //
// ./src/components/toasts/toasts.container.tsx